export const getImageKey = (deviceId, insightId, algId, className, table) => {
  return `${deviceId}:${insightId}:${algId}:${className.replace(" ", "_")}:${table}`
}

export const getPhotoUrl = (insightId, algId, className) => {
  return `${algId}/${className.replace(" ", "_")}/${insightId}.jpeg`
}
